<template>
  <div class="sj-timeSwitch">
    <div class="sj-timeSwitch-preBox">
      <template v-if="!hidePre">
        <SjIcon
          class="sj-timeSwitch-rolate"
          iconClass="comcalender_nextgap"
          :size="16"
          :iconSize="11"
          @click="handlePreParent"
        ></SjIcon>
        <SjIcon
          class="sj-timeSwitch-rolate"
          iconClass="compagi_next"
          :size="16"
          :iconSize="11"
          style="margin-right: 10px;margin-left: 10px;"
          @click="handlePre"
          v-if="type !== 'year'"
        ></SjIcon>
      </template>
    </div>

    <template v-if="showLabel">
      <div class="sj-timeSwitch-input-label-wrapper" v-if="enableInputChecker">
        <SjDropdown
          :ref="'dropdown-' + item.ref"
          placement="bottom"
          trigger="click"
          :arrowVisible="false"
          class="sj-drop-down"
          v-for="(item, index) in showInputValue"
          :key="item.format"
        >
          <div
            slot="reference"
            class="sj-timeSwitch-input-container"
            :class="[{ 'margin-right': index !== showInputValue.length - 1 }]"
          >
            <sj-input
              class="sj-timeSwitch-input"
              border
              size="mini"
              v-model="item.input"
              :ref="item.ref"
              v-show="item.isEditMode"
              @blur="onInputBlur(item)"
              @keyup.enter="onInputKeyUp(item)"
            ></sj-input>
            <p
              v-show="!item.isEditMode"
              @click="onItemEditModeCheck(item, index)"
              class="sj-timeSwitch-input-label-item"
            >
              {{ item.format === "YYYY" ? item.label + "年" : item.label }}
            </p>
          </div>
          <div slot="dropdown">
            <pop-selector
              @change="val => onInputBlur(item, val)"
              v-model="item.input"
              :type="item.format === 'YYYY' ? 'year' : 'month'"
            ></pop-selector>
          </div>
        </SjDropdown>
      </div>

      <div v-else class="sj-timeSwitch-label">{{ showValue }}</div>
    </template>
    <div class="sj-timeSwitch-nextBox">
      <template v-if="!hideNext">
        <SjIcon
          iconClass="compagi_next"
          :size="16"
          :iconSize="11"
          style="margin-right: 10px;margin-left: 10px;"
          v-if="type !== 'year'"
          @click="handleNext"
        ></SjIcon>
        <SjIcon
          iconClass="comcalender_nextgap"
          :size="16"
          :iconSize="11"
          @click="handleNextParent"
        ></SjIcon>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import dateMixin from "../mixin";
import PopSelector from "./popSelector";

export default {
  components: { PopSelector },
  mixins: [dateMixin],
  props: {
    value: Number,
    type: {
      type: String,
      default: "month",
      validator(v) {
        return ["date", "month", "year"].indexOf(v) !== -1;
      }
    },
    format: String,
    hidePre: {
      type: Boolean,
      default: false
    },
    hideNext: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    intervalNum: Number,
    // 文本输入选择器，点击文本可切换输入框
    enableInputChecker: {
      type: Boolean
    }
  },
  data() {
    return {
      showInputValue: [],
      typeConfig: {
        date: {
          format: "YYYY年M月D日",
          interval: "day",
          intervalParent: "month",
          inputShowConfig: [
            {
              format: "YYYY",
              isEditMode: false
            },
            {
              format: "MMM", // MMM为自定义时区格式，这里我们使用的是一月、二月大写格式
              isEditMode: false
            }
          ]
        },
        month: {
          format: "YYYY年M月",
          interval: "month",
          intervalParent: "year",
          inputShowConfig: [
            {
              format: "YYYY",
              isEditMode: false
            },
            {
              format: "MMM",
              isEditMode: false
            }
          ]
        },
        year: {
          format: "YYYY年",
          intervalParent: "year",
          inputShowConfig: [
            {
              format: "YYYY",
              isEditMode: false
            }
          ]
        }
      }
    };
  },
  computed: {
    currentConfig() {
      const { format, type, typeConfig } = this;
      return format || typeConfig[type];
    },
    showValue() {
      const { value, currentConfig } = this;
      return moment(value).format(currentConfig.format);
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        moment.locale("zh-cn");
        this.showInputValue = this.currentConfig.inputShowConfig.map(
          (item, index) =>
            Object.assign({
              label: moment(this.value).format(item.format),
              format: item.format,
              isEditMode: item.isEditMode,
              input: moment(this.value).format(item.format),
              ref: item.format + index // input输入框的ref，用来获取焦点
            })
        );
      }
    }
  },
  methods: {
    onInputKeyUp(item) {
      this.onInputBlur(item);
      const dropdown = this.$refs["dropdown-" + item.ref];
      if (dropdown && dropdown.length > 0) {
        this.$nextTick(() => {
          dropdown[0].doClose();
        });
      }
    },

    onInputBlur(item) {
      item.isEditMode = false;
      if (item.format === "YYYY") {
        if (this.isNotNumber(item.input)) {
          item.input = item.label;
          return;
        }

        const year = Number.parseInt(item.input);
        if (year < 0 || year > 9999) {
          item.input = item.label;
          return;
        }

        const date = new Date(this.value);
        date.setFullYear(year);
        this.emitInput(date.getTime());
        return;
      }

      if (item.format === "MMM") {
        const month = this.monthMapper[item.input];
        if (month === undefined) {
          item.input = item.label;
          return;
        }
        const date = new Date(this.value);
        date.setMonth(month);
        this.emitInput(date.getTime());
      }
    },
    onItemEditModeCheck(item) {
      item.isEditMode = true;
      if (!this.$refs[item.ref] || !this.$refs[item.ref][0]) {
        return;
      }
      this.$nextTick(() => this.$refs[item.ref][0].focus());
    },
    handlePre() {
      const { value, type, typeConfig, getPreDate, emitInput } = this;
      const interval = typeConfig[type].interval;
      emitInput(getPreDate(value, interval));
    },
    handlePreParent() {
      const { value, type, typeConfig, getPreDate, emitInput } = this;
      const interval = typeConfig[type].intervalParent;
      emitInput(getPreDate(value, interval, this.intervalNum));
    },
    handleNext() {
      const { value, type, typeConfig, getNextDate, emitInput } = this;
      const interval = typeConfig[type].interval;
      emitInput(getNextDate(value, interval));
    },
    handleNextParent() {
      const { value, type, typeConfig, getNextDate, emitInput } = this;
      const interval = typeConfig[type].intervalParent;
      emitInput(getNextDate(value, interval, this.intervalNum));
    },
    emitInput(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
};
</script>

<style lang="less" scoped>
.sj-timeSwitch {
  position: relative;
  padding: 0 12px;
  height: 30px;
  /deep/.sj-dropdown {
    border: none;
  }

  .sj-timeSwitch-preBox,
  .sj-timeSwitch-nextBox {
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;

    .sj-timeSwitch-rolate {
      transform: rotate(180deg);
    }

    /deep/ .sj-icon:hover {
      background-color: @color-gray-2;
    }
  }

  .sj-timeSwitch-preBox {
    left: 12px;
  }

  .sj-timeSwitch-nextBox {
    right: 12px;
  }

  .sj-timeSwitch-input-label-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    cursor: pointer;
    .sj-timeSwitch-input-container {
      .sj-timeSwitch-input {
        width: 40px;
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center;
      }
      .sj-timeSwitch-input-label-item {
        min-width: 40px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        .text("caption", "dark");
      }

      &.margin-right {
        margin-right: 10px;
      }
    }
  }

  .sj-timeSwitch-label {
    padding: 0 52px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    .text("caption", "dark");
  }
}
</style>
